
import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import MatrixBackground from '../components/MatrixBackground';
import ScanLines from '../components/ScanLines';
import Header from '../components/Header';

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
    
    // Change title
    document.title = 'Access Denied | SpecialAgentK';
  }, [location.pathname]);

  return (
    <div className="bg-cyber-black text-cyber-green min-h-screen">
      <MatrixBackground />
      <ScanLines />
      <Header />
      
      <div className="min-h-screen flex items-center justify-center px-4">
        <div className="cyber-box max-w-xl w-full text-center">
          <span></span>
          <div className="py-8">
            <h1 className="text-6xl font-pixel text-cyber-red mb-4 animate-flicker">404</h1>
            <div className="w-24 h-1 bg-cyber-green mx-auto mb-6"></div>
            <h2 className="text-2xl font-cyber mb-4 text-shadow-glow">ACCESS DENIED</h2>
            <p className="font-cyber mb-6">
              The system could not verify your security clearance for the requested file.
            </p>
            <div className="flex justify-center">
              <Link 
                to="/" 
                className="inline-block font-cyber px-8 py-3 border border-cyber-green text-cyber-green hover:bg-cyber-green hover:text-cyber-black transition-all duration-300 relative overflow-hidden group"
              >
                <span className="relative z-10">RETURN TO MAINFRAME</span>
                <span className="absolute inset-0 bg-cyber-green transform translate-y-full group-hover:translate-y-0 transition-transform duration-300"></span>
              </Link>
            </div>
          </div>
          <span></span>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
